import * as types from '../actions/types';

const storedToken = sessionStorage.getItem('token');
const storedScreenLock = localStorage.getItem('screenLock');

const initialState = {
  isAuth: storedToken ? true : false,
  isLockedScreen: storedScreenLock ? true : false,
  isErrorHandlerActive: false,
  errorHandlerMessage: "",
  errorHandlerTitle: "",
  errorHandlerOnlyCloseButton: false,
  isLogout: false,
  loading: false,
  changePassword: {
    error: null,
    successMessage: '',
    loading: false,
  },
  requestLogout: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    // LOGIN
    case types.LOGIN_USER_REQUEST:
      return { ...state, loading: true, error: null };
    case types.LOGIN_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        isAuth: action.payload,
        isLockedScreen: false,
      };
    case types.LOGIN_USER_FAILED:
      return { ...state, loading: false, error: payload };
    case types.ERROR_HANDLING_SERVICES:
      return { ...state, isErrorHandlerActive: payload.visible, errorHandlerMessage: payload.message, errorHandlerTitle: payload.title, errorHandlerOnlyCloseButton: payload.onlyCloseButton };

    // CHANGE PASSWORD
    case types.CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        changePassword: {
          ...state.changePassword,
          loading: true,
          error: null,
          message: '',
        },
      };
    case types.CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changePassword: {
          ...state.changePassword,
          loading: false,
          error: null,
          successMessage: payload,
        },
      };
    case types.CHANGE_PASSWORD_FAILED:
      return {
        ...state,
        changePassword: {
          ...state.changePassword,
          loading: false,
          error: payload,
          successMessage: '',
        },
      };
    case types.CLEAR_CHANGE_PASSWORD:
      return {
        ...state,
        changePassword: {
          error: null,
          successMessage: '',
          loading: false,
        },
      };

    // LOGOUT
    case types.LOGOUT_USER_REQUEST:
      return {
        ...state,
        requestLogout: true,
      };
    case types.LOGOUT_USER_SUCCESS:
      return {
        ...state,
        isLogout: action.payload,
        isAuth: false,
        requestLogout: false,
      };
    case types.LOGOUT_USER_FAILED:
      return {
        ...state,
        isLogout: action.payload,
        isAuth: false,
        requestLogout: false,
      };

    case types.LOCK_SCREEN:
      return { ...state, isLockedScreen: true };
    default:
      return state;
  }
}
